import { z } from 'zod';
import { PAGE_SIZE_DEFAULT, PAGE_SIZE_MAX } from '../constants.js';
export const uuidSchema = z.string().uuid();
export const cursorQuerySchema = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(PAGE_SIZE_MAX).default(PAGE_SIZE_DEFAULT),
});
export function paginated(item) {
    return z.object({
        items: z.array(item),
        nextCursor: z.string().nullable(),
    });
}
export const nonEmptyTrimmed = (max) => z.string().trim().min(1).max(max);
export const optionalTrimmed = (max) => z.string().trim().max(max).optional();
export const moneyCents = z.number().int().min(0);
export const emailSchema = z.string().trim().toLowerCase().email().max(254);
export const phoneSchema = z.string().trim().max(30);
export const dateRangeQuerySchema = z.object({
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
});
//# sourceMappingURL=common.js.map